import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

export type CPHeaderLocs = 'CPHeaderHelpDeskButton';

export type CPHeaderLocType = LocMap<CPHeaderLocs>;

export const cpSharedViewHeaderLocs: LocDefs<CPHeaderLocs> = {
	CPHeaderHelpDeskButton: {
		defaultValue: 'Help',
		description: 'The help button on the view header (Comptia Custom).',
		displayType: 'Button',
		displayPath: `Candidate Portal|Header|Help Button`,
		feature: HubFeature.CandidateAccessShowHelpDeskButton,
		portal: 'CP',
		htmlAllowed: false,
		shared: false,
	},
};

export const CPHeaderLocs = MapLocKeys<CPHeaderLocs>(cpSharedViewHeaderLocs);
